"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  galleryItemNumbProp: 8,
  columnsCountProp: 4,
  aspectRatioProp: 'auto',
  loaderFormatProp: 'all',
  autoFillInProp: true,
  imagesAutoResizeProp: false,
  hideLoaderPreviewImage: false,
  hideLoaderFullImage: false,
  imagesMinWidthProp: '80',
  imagesMaxWidthProp: '1fr',
  borderWidthProp: '10',
  offScrollProp: true
};
exports["default"] = _default;